var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRecently = function SvgRecently(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.636 2.542A6.52 6.52 0 0 0 7.326.054 6.51 6.51 0 0 0 2.57 1.31l-.5-.5c-.141-.142-.27-.09-.295.102L1.62 2.696a.304.304 0 0 0 .333.333l1.77-.154c.205-.013.244-.154.103-.295l-.513-.513a5.418 5.418 0 0 1 3.873-.974 5.409 5.409 0 0 1 3.616 2.077 5.41 5.41 0 0 1 1.077 4.027 5.318 5.318 0 0 1-1.192 2.744 5.19 5.19 0 0 1-.898.86 5.41 5.41 0 0 1-4.027 1.076c-1.423-.166-2.706-.91-3.59-2.064a5.396 5.396 0 0 1-1.09-3.924.52.52 0 0 0-.462-.577c-.282-.039-.539.18-.577.461a6.396 6.396 0 0 0 1.308 4.681 6.49 6.49 0 0 0 4.309 2.488 6.388 6.388 0 0 0 4.796-1.295 6.74 6.74 0 0 0 1.064-1.026 6.327 6.327 0 0 0 1.41-3.27 6.515 6.515 0 0 0-1.294-4.81Z",
    fill: "#212838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.237 2.272a.427.427 0 0 0-.424.424v4.219l3.848 1.987a.405.405 0 0 0 .564-.18.421.421 0 0 0-.18-.563L6.66 6.389V2.696a.427.427 0 0 0-.423-.424Z",
    fill: "#212838"
  })));
};

export default SvgRecently;